module.exports = __webpack_public_path__ + "img/facebook.684cddb3.png";